import { render } from "./ModalNewAzienda.vue?vue&type=template&id=52411ed6&scoped=true"
import script from "./ModalNewAzienda.vue?vue&type=script&lang=js"
export * from "./ModalNewAzienda.vue?vue&type=script&lang=js"

import "./ModalNewAzienda.vue?vue&type=style&index=0&id=52411ed6&scoped=true&lang=css"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52411ed6"]])

export default __exports__